import { BalanceSheet } from "../gateway/BalanceSheet/BalanceSheet";

export class ImportBalanceSheetUsecase {
    constructor() {
        this.BalanceSheetGateway = new BalanceSheet();
    }

    async execute({
        companyId = "",
        accountingId = "",
        balanceSheet = "",
        date,
        system = "",
        ignoreError = false,
        userId = "",
        bulkImport = true
    } = {}) {
        const payload = this.sanitizeInput({
            companyId,
            accountingId,
            balanceSheet,
            date,
            system,
            ignoreError,
            userId,
            bulkImport
        });
        if (!payload.companyId) return null;
        if (!payload.accountingId) return null;
        if (!payload.balanceSheet) return null;
        return await this.BalanceSheetGateway.import(payload);
    }

    sanitizeInput({
        companyId = "",
        accountingId = "",
        balanceSheet = "",
        date,
        system = "",
        ignoreError = false,
        userId = "",
        bulkImport = true
    } = {}) {
        const payload = {
            companyId: String(companyId),
            accountingId: String(accountingId),
            balanceSheet: String(balanceSheet),
            ignoreError: Boolean(ignoreError),
            bulkImport: bulkImport === undefined ? true : Boolean(bulkImport)
        };
        const sanitizedDate = this.sanitizeDate(date);
        if (sanitizedDate) payload.date = sanitizedDate;
        const sanitizedSystem = String(system);
        if (sanitizedSystem) payload.system = sanitizedSystem;
        const sanitizedUserId = String(userId);
        if (sanitizedUserId) payload.userId = sanitizedUserId;
        return payload;
    }

    sanitizeDate(date) {
        if (!date || typeof date !== "object") return null;
        const month = Number(date.month);
        const year = Number(date.year);
        const sanitizedDate = {};
        if (!Number.isNaN(month) && month >= 1 && month <= 12) {
            sanitizedDate.month = month;
        }
        if (!Number.isNaN(year)) {
            sanitizedDate.year = year;
        }
        if (!sanitizedDate.month && !sanitizedDate.year) return null;
        return sanitizedDate;
    }
}
